import { BASE_URL } from "../constants";

// Uploaded files (chat attachments, profile photos) are either absolute URLs (S3) or paths on the API host
// (local disk storage, e.g. "/api/uploads/avatars/x.webp").
export const resolveFileUrl = (url) => {
  if (!url || /^(https?:|blob:|data:)/i.test(url)) return url;
  return `${BASE_URL.replace(/\/$/, "")}${url}`;
};
